module.exports = __webpack_public_path__ + "media/images/locations/japan-cbcfbcb1b1d66961e6b9f963c9dca41a.jpg";